import React from 'react';
import clsx from 'clsx';
import { useTranslation } from 'react-i18next';

import Tr from '../../../../components/common-table/components/Tr';
import Td from '../../../../components/common-table/components/Td';
import { ICONS } from '../../../../icons';
import CommonIconButton from '../../../../components/common-icon-button/CommonIconButton';
import CommonCheckbox from '../../../../components/common-checkbox/CommonCheckbox';
import CommonButtonLink from '../../../../components/common-button-link/CommonButtonLink';
import { BUTTON_STYLES } from '../../../../components/common-button/CommonButton';
import CircleCounter from '../../../../components/circle-counter/CircleCounter';
import { MODAL_TYPES } from '../../../../constants';

import scss from './UsersTable.module.scss';

const UsersTableItem = ({ user, onDelete, onEdit, onEnable, onChangeUserProjects }) => {
  const { username, enabled, firstName, lastName, actionedBy, assignedProjects } = user;

  const { t } = useTranslation('customers');

  const handleDelete = () => {
    onDelete({ ...user, modalType: MODAL_TYPES.DELETE });
  };

  const handleEdit = () => {
    onEdit(user);
  };
  const handleEnable = () => {
    onEnable(user);
  };

  const handleChangeProjects = () => {
    onChangeUserProjects({ ...user, modalType: 'CHANGE_PROJECT' });
  };

  return (
    <Tr>
      <Td isLeft>
        <span className={scss.cellUser}>{username}</span>
      </Td>
      <Td isLeft>{`${firstName} ${lastName}`}</Td>
      <Td isLeft extraClasses={scss.cellProjects}>
        <CommonButtonLink styleColor={BUTTON_STYLES.SECONDARY} onClick={handleChangeProjects} type='button'>
          {t('projects')}
        </CommonButtonLink>

        <CircleCounter count={assignedProjects.length} />
      </Td>
      <Td extraClasses={scss.cellEnable}>
        <CommonCheckbox checked={enabled} onChange={handleEnable} />
      </Td>
      <Td isLeft extraClasses={clsx(!enabled && scss.cellDeactivated)}>
        {actionedBy}
      </Td>
      <Td isLeft extraClasses={scss.cellAction}>
        <CommonIconButton icon={ICONS.Edit} onClick={handleEdit} disabled />
        <CommonIconButton icon={ICONS.Delete} onClick={handleDelete} />
      </Td>
    </Tr>
  );
};

export default UsersTableItem;
